import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6"
      style={{ background: "var(--bg)" }}>
      <Helmet>
        <title>Starting Five - Page introuvable</title>
      </Helmet>

      <div style={{
        fontFamily: "var(--font-display)",
        fontSize: "clamp(6rem, 20vw, 12rem)",
        color: "#E0392B",
        WebkitTextStroke: "3px var(--ink)",
        textShadow: "6px 6px 0 var(--ink)",
        lineHeight: 1,
      }}>
        404
      </div>

      <h2 style={{
        fontFamily: "var(--font-display)",
        fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
        color: "var(--ink)",
        marginTop: 16,
        marginBottom: 12,
      }}>
        Page introuvable
      </h2>

      <p style={{ color: "var(--ink-soft)", fontWeight: 500, marginBottom: 32, maxWidth: 400 }}>
        La page que tu cherches n'existe pas ou a été déplacée.
      </p>

      <Link to="/" className="brut-btn brut-btn-primary">
        ← Retour à l'accueil
      </Link>
    </div>
  );
}